import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M2.034 7.445c-.318-1.843 1.683-3.202 3.279-2.227l6.418 3.92a10.8 10.8 0 0 0-6.303 8.155l-.599-.21a2.18 2.18 0 0 1-1.426-1.685z"></path><path d="M10.97 25.584c-.112.056.113-.038 0 0 1.59.972 3.413 1.529 5.352 1.529 1.873 0 3.637-.519 5.188-1.43.017.006.004-.005.02 0-.01-.005.01.006 0 0l-5.337-2.928z"></path><path d="m26.694 17.25.477-.167a2.18 2.18 0 0 0 1.426-1.685l1.37-7.953c.317-1.843-1.684-3.202-3.28-2.227l-6.365 3.888a10.8 10.8 0 0 1 6.372 8.144"></path><path fill-rule="evenodd" d="M17.542 21.472c.187-.272.296-.6.296-.953 0-.944-.78-1.71-1.741-1.71s-1.742.766-1.742 1.71c0 .383.13.737.346 1.022l-4.95 2.644a1.5 1.5 0 0 1-2.191-1.11l-.4-2.802c-.773-5.419 3.431-10.266 8.904-10.266 5.474 0 9.679 4.847 8.905 10.266l-.393 2.76a1.49 1.49 0 0 1-2.192 1.095zm-6.604-2.082a1.16 1.16 0 1 0 0-2.321 1.16 1.16 0 0 0 0 2.321m11.866-1.16a1.16 1.16 0 1 1-2.322 0 1.16 1.16 0 0 1 2.322 0" clip-rule="evenodd"></path></g>';
export var DogSmallSVG = function DogSmallSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
DogSmallSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(DogSmallSVG);